import {Directive, HostBinding, HostListener, input} from '@angular/core';

@Directive({
	selector: '[DisableUserAction]',
	standalone: true,
})
export class DisableUserActionDirective {
	@HostBinding('style.user-select') userSelectStyle = 'none';

	readonly disableClick = input(false);
	readonly disableKeyboard = input(false);

	@HostListener('click', ['$event']) onClick(event: MouseEvent) {
		if (this.disableClick()) {
			event.stopPropagation();
		}
	}
}
